import React from "react";
import MaterialSelect from "../../../../components/MasterSelect";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import Grid from "@mui/material/Grid2";
import MaterialBox from "../../../../components/MaterialBox";
import { FormControl, FormHelperText } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
function Allocation({
  accrualmethod,
  handleChange,
  leaveconfigdata,
  togglePage,
  handleleaveconfigdataChange,
  allocationdays,
  handleallocation,
}) {
  return (
    <MaterialBox>
      <Grid container spacing={2}>
        <Grid size={{ xs: 4, sm: 4 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Accrual Method <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>

          <MaterialSelect
            name="accrualMethod"
            isSearchable
            onChange={handleallocation}
            error={leaveconfigdata.accrualMethodStatus === "error"}
            success={leaveconfigdata.accrualMethodStatus === "success"}
            value={leaveconfigdata.accrualMethod}
            options={accrualmethod.map((val) => {
              return {
                value: val.value,
                label: val.label,
              };
            })}
            isDisabled={togglePage.view === true ? true : false}
          />
        </Grid>
        <Grid size={{ xs: 4, sm: 4 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Allocation Day <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>

          <MaterialSelect
            name="allocationday"
            isSearchable
            onChange={handleallocation}
            value={leaveconfigdata.allocationday}
            error={leaveconfigdata.allocationdayStatus === "error"}
            success={leaveconfigdata.allocationdayStatus === "success"}
            options={allocationdays.map((val) => {
              return {
                value: val.value,
                label: val.label,
              };
            })}
            isDisabled={togglePage.view === true ? true : false}
          />
        </Grid>
        <Grid ml={5}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Half Day
            </MaterialTypography>
          </MaterialBox>

          <FormControlLabel
            control={
              <Switch
                checked={leaveconfigdata.halfday}
                onChange={(e) =>
                  handleleaveconfigdataChange({
                    target: {
                      name: "halfday",
                      value: e.target.checked,
                    },
                  })
                }
                color="primary"
              />
            }
            label={leaveconfigdata.halfday ? "Yes" : "No"}
            disabled={togglePage.view === true ? true : false}
          />
        </Grid>
      </Grid>
    </MaterialBox>
  );
}

export default Allocation;
